import React from 'react';
import LeftForm from './LeftForm';
import RightForm from './RightForm';

export default function InsuranceCompanyWrapper(props) {
  const { Styled } = props;
  return (
    <Styled.InsuranceCompanyWrapper>
      <LeftForm {...props} />
      <RightForm {...props} />
    </Styled.InsuranceCompanyWrapper>
  );
}
